import React, { useEffect, useState } from 'react'
import Config from '../Config';
import Toastmodal from '../Toastmodal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import { FiPlusCircle } from 'react-icons/fi';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import Allimagestyle from '../Blog/Allimage_style';
import Allimageselect from '../Blog/Allimageselect';
import moment from 'moment';
import Select from 'react-select';

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");

function Propertyedit() {
  const locations = useLocation();
  const levels=locations.state.level

    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let navigate = useNavigate();
    let { id } = useParams();

    const [property , setProperty] = useState([]);
  
   const [toastmodal, setToastmodal] = useState(false);
   const [toastmessage, setToastmessage] = useState("");
   const [toasttype, setToasttype] = useState("");
   const [toastlarge, setToastlarge] = useState(false);
  
   const [selectedImageId, setSelectedImageId] = useState([]);
   const [uploadedImages, setUploadedImages] = useState([]);
 
   const [formerror, setError] = useState({});
  
  let name , value;
  const maxDate= moment(new Date).utc().format("YYYY-MM-DD")

  const [selectedAminities, setSelectedAminities] = useState([]);
  const [aminity, setAminity] = useState([]);
  const [newAminity, setNewAminity] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [location, setLocation] = useState({
    name: "Kochi, Kerala, India",
    lat: 9.9312,
    long: 76.2673,
  });

  const [loc, setLoc] = useState("Kochi, Kerala, India");
  const [propertytype, setProprtytype] = useState([]);
  const [cust, setCust] = useState([]);
  const [useroption,setUseroption]=useState([]);
  const [selecteduser,setSelecteduser]=useState([]);

  const [selectedtype, setselectedType] = useState('');
  const [property_option, setPropertyoption] = useState('');

  const [addressstring, setaddressstring] = useState(
    "W7M9+9C Kochi, Kerala, India"
  );
  const [subloc,setSubloc]=useState('Kochi');
  const [city,setCity]=useState('Kochi');
  const [country,setCountry]=useState('India');
  const [district,setDistrict]=useState('Ernakulam');
  const [state,setState]=useState('Kerala');
  const [selectedptype,setSelectedptype]=useState('');
  const [contactPerson,setContactperson]=useState('');
  const [aminityall, setAminityall] = useState([]);

  // const handleInputs = (e) => {
  //   name = e.target.name;
  //   value = e.target.value;

  //   if(name==='status'){
  //       if(value==='Sold Out'){
  //         setProperty({ ...property, ['soldout']:true });
  //       }
  //       else{
  //         setProperty({ ...property, ['soldout']:false});
  //       }
  //   }
  //   if(name==='soldout'){
  //     if(value===true || value==='true'  ){
  //       setProperty({ ...property, ['status']:'Sold Out' });

  //     }
  //   }
  //   setProperty({ ...property, [name]: value });
  // }

  const handleInputs = (e) => {
    // Use object destructuring for a cleaner way to get name and value
    const { name, value } = e.target;
  
    // Create a new object to hold the updated state
    let updatedProperty = { ...property, [name]: value };
  
    // Conditionally update soldout based on the new status value
    if (name === 'status') {
      if (value === 'Sold Out') {
        updatedProperty.soldOut = 'true'; // Set to a string to match the option value
      } else {
        updatedProperty.soldOut = 'false'; // Set to a string to match the option value
      }
    }
    
    // Conditionally update status based on the new soldOut value
    if (name === 'soldOut') {
      if (value === 'true') {
        updatedProperty.status = 'Sold Out';
      } 
      else{
        updatedProperty.status = 'Unlisted';
      }
    }
  
    // Set the state once with the final updated object
    setProperty(updatedProperty);
  };


  const handleInputstype = (e, slug) => {
    name = e.target.name;
    value = e.target.value;
    selectedptype(value);
    // setProperty({ ...property, [name]: value });
    setselectedType(slug);
  }
  const onFileChange = (e) => {
    let name = e.target.name;
    setProperty({ ...property, [name]: e.target.files });
  };

  const handleCheckboxChange = (value) => {
    if (value === 'Others') {
      setShowInput(!showInput);
      if (selectedAminities.includes(value)) {
        setSelectedAminities(selectedAminities.filter((item) => item !== value));
      } else {
        setSelectedAminities([...selectedAminities, value]);
      }
    } else {
      if (selectedAminities.includes(value)) {
        setSelectedAminities(selectedAminities.filter((item) => item !== value));
      } else {
        setSelectedAminities([...selectedAminities, value]);
      }
    }
  };
  const handleAddAminity = () => {
    if (newAminity) {
      const am = {title: newAminity }
      setSelectedAminities([...selectedAminities, newAminity]);
      setAminity([...aminity, am])
      setNewAminity('');
    }
  };


  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
    setLoc(value);
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    const addressComponents = results[0].address_components;
    let subLocation = "";
      let city = "";
      let country = "";
      let district = "";
      let state = "";
      // Loop through the address components to extract the required info
      addressComponents.forEach((component) => {
        const types = component.types;

        // Extract sub-location (neighborhood or administrative area)
        if (types.includes("sublocality") || types.includes("neighborhood")) {
          subLocation = component.long_name;
        }

        
        
      if (types.includes("administrative_area_level_2") || types.includes("locality") || types.includes("administrative_area_level_3") ) {
          district = component.long_name;
          
        }
        // Extract city (locality)
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }

        // Extract country
        if (types.includes("country")) {
          country = component.long_name;
        }

      })
      
      

      setSubloc(subLocation || city || district || state || country);
      setCity(city || district || state || country);
      setDistrict(district || state || country);
      setState(state || country);
      setCountry(country);

    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
    setLoc(value);
  };

   const getinfo = async (e) => {
    let Url;
    if(levels==='sell'){
      Url='/api/v1/crm/property/get-property/';
    }
    else{
        Url='/api/v1/crm/rent/get-property/';
    }

    const res = await fetch(`${Config.apiurl}${Url}${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();
      setProperty(data.data);
      setAminityall(data.data.amenities)
      setLocation({
        name:data.data.propertyLocation,
        lat:data.data.propertyLocationKey.coordinates[1],
        long:data.data.propertyLocationKey.coordinates[0]
      })
      setaddressstring(data.data.google_address_string);
      setSubloc(data.data.propertySubLocation);
      setCity(data.data.propertyCity);
      setDistrict(data.data.propertySubLocation);
      setSelectedptype(data.data?.propertyType?._id)
      setContactperson(data.data?.contactPerson?._id)

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      console.log("error");
    }
  };

  
 
  
   const PostData = async (e) => {
     e.preventDefault();
     let formvalid=true;
     const errors = {};
     if (!property.propertyAdTitle) {
      errors.propertyAdTitle = "Property title is required!";
      formvalid = false;
    }
    if (!property.propertyName) {
      errors.propertyName = "Property name is required!";
      formvalid = false;
    }
    if (!property.description) {
      errors.description = "Property description is required!";
      formvalid = false;
    }
    
    if (!selecteduser?.value) {
      errors.contactPerson = "Contact person is required!";
      formvalid = false;
    }
    

    if (!selectedptype) {
      errors.propertyType = "Property type is required!";
      formvalid = false;
    }
    if (!property.listedBy) {
      errors.listedBy = "Listed by is required!";
      formvalid = false;
    }
    if (!property.metaTitle) {
      errors.metaTitle = "Meta title is required!";
      formvalid = false;
    }
   
    if (!property.status) {
      errors.status = "status is required!";
      formvalid = false;
    }

    if (!property.canonicalURL) {
      errors.canonicalURL = "Canonical URL is required!";
      formvalid = false;
    }
    
    if (selectedImageId.length===0){
      if(property?.propertyImages?.length===0){
      errors.image = "File is required!";
      formvalid=false;
      }
  }
    //  if ( property.file && property.file.length!==0) {
    //      for (var i = 0; i < property.file.length; i++) {
    //       if (
    //         property.file[i].type == "image/jpeg" ||
    //         property.file[i].type == "image/jpg" ||
    //         property.file[i].type == "image/png" ||
    //         property.file[i].type == "image/webp"
            
    //       ) {
           
    //         console.log();
  
    //       } else {
    //         errors.image = "Only support jpg, jpeg, png, webp image!";
    //         formvalid=false;

    //       }
    //     }


    //  }
     if(selectedtype==='house' ||  selectedtype==='apartment' ||selectedtype==='villas'){
        if (!property.bedrooms) {
          errors.bedrooms = "Bed room is required!";
          formvalid = false;
        }
        if (!property.bathrooms) {
          errors.bathrooms = "Bath room is required!";
          formvalid = false;
        }
        // if (!property.balcony) {
        //   errors.balcony = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.buildUpArea) {
          errors.buildUpArea = "This field is required!";
          formvalid = false;
        }
        if (!property.carpetArea) {
          errors.carpetArea = "This field is required!";
          formvalid = false;
        }
        if (!property.furnished) {
          errors.furnished = "This field is required!";
          formvalid = false;
        }

       
        // if (!property.noOfFloors) {
        //   errors.noOfFloors = "This field is required!";
        //   formvalid = false;
        // }
        // if (!property.garage) {
        //   errors.garage = "This field is required!";
        //   formvalid = false;
        // }
        // if (!property.roadWidth) {
        //   errors.roadWidth = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }
    }
    if(selectedtype==='house' ||  selectedtype==='villas'){
        if (!property.plotArea) {
          errors.plotArea = "This field is required!";
          formvalid = false;
        } 
     }
    if(selectedtype==='apartment' ){
        if (!property.type) {
          errors.type = "This field is required!";
          formvalid = false;
        }
        if (property.noOfFloors) {
          if (!property.floorNumber) {
            errors.floorNumber = "This field is required!";
            formvalid = false;
          }
        }
        // if (!property.floorNumber) {
        //   errors.floorNumber = "This field is required!";
        //   formvalid = false;
        // }
     
     }

     if(selectedtype==='plots' ){
        if (!property.plotArea) {
          errors.plotArea = "This field is required!";
          formvalid = false;
        }
        if (!property.length) {
          errors.length = "This field is required!";
          formvalid = false;
        }
        if (!property.breadth) {
          errors.breadth = "This field is required!";
          formvalid = false;
        }
        // if (!property.roadWidth) {
        //   errors.roadWidth = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }
      
        
     
     }

     if(selectedtype==='office-space' ){
        if (!property.buildUpArea) {
          errors.buildUpArea = "This field is required!";
          formvalid = false;
        }
        if (!property.carpetArea) {
          errors.carpetArea = "This field is required!";
          formvalid = false;
        }
        if (!property.furnished) {
          errors.furnished = "This field is required!";
          formvalid = false;
        }
        if (property.noOfFloors) {
          if (!property.floorNumber) {
            errors.floorNumber = "This field is required!";
            formvalid = false;
          }
        }
        // if (!property.noOfFloors) {
        //   errors.noOfFloors = "This field is required!";
        //   formvalid = false;
        // }
        // if (!property.floorNumber) {
        //   errors.floorNumber = "This field is required!";
        //   formvalid = false;
        // }
      
        // if (!property.garage) {
        //   errors.garage = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }
      
   
     }

     if(levels==='rent' && selectedtype!=='plots'){
      if (!property.maintenanceCharge) {
        errors.maintenanceCharge = "This field is required!";
        formvalid = false;
      }
      
     }

    if(property?.soldOut===true || property?.soldOut==='true' ){
      if (!property.soldOutDate) {
        errors.soldOutDate = "This field is required!";
        formvalid = false;
      }
    }
     setError(errors);
    if(formvalid===true){
      let Urls;
      if(levels==='sell'){
        Urls='/api/v1/crm/property/update-property-info/';
      }
      else{
          Urls='/api/v1/crm/rent/update-property-info/';
      }
      //   const formData = new FormData();
      //   formData.append("property_name", property.propertyName);
      //   formData.append("property_ad_title", property.propertyAdTitle);
      //   formData.append("description", property.description);
      //   formData.append("contact_person", contactPerson);
      //   formData.append("property_type", selectedptype);
      //   if(property.yearOfConstruction){
      //   formData.append("year_of_construction", Number(property.yearOfConstruction));
      //   }
      //   if(property.listedBy){
      //     formData.append("listed_by", property.listedBy);
      //   }
      //   if(property.condition){
      //     formData.append("condition", property.condition);
      //   }
      //   formData.append("property_location", location.name);
      //   formData.append("google_address_string", addressstring);
      //   formData.append("property_city", city);
      //   formData.append("property_country", country);
      //   formData.append("property_sub_location", subloc);
      //   formData.append("longitude", location.long);
      //   formData.append("latitude", location.lat);
      //   if(property.file && property.file.length>0){
      //   for(var i=0;i<property.file.length;i++){
      //     formData.append("files", property.file[i]);
      //   }
      // }
      //   formData.append("status", property.status);
      //   formData.append("meta_title", property.metaTitle);
      //   formData.append("meta_description", property.metaDescription);
      //   formData.append("canonicalURL", property.canonicalURL);
  
      //   if(selectedtype==='house' || selectedtype==='apartment' || selectedtype==='villas'){
      //     formData.append("bedrooms",property.bedrooms);
      //     formData.append("bathrooms", Number(property.bathrooms));
      //     formData.append("balcony", Number(property.balcony));
      //     formData.append("build_up_area", Number(property.buildUpArea));
      //     formData.append("carpet_area", Number(property.carpetArea));
      //     formData.append("furnished", property.furnished);
      //     formData.append("no_of_floors", Number(property.noOfFloors));
      //     formData.append("garage", Number(property.garage));
      //     formData.append("road_width", Number(property.roadWidth));
      //     formData.append("price", Number(property.price));
  
      //   }
  
      //   if(selectedtype==='apartment'){
      //     formData.append("type", property.type);
      //     formData.append("floor_number", Number(property.floorNumber));
      //    for(var i=0;i<selectedAminities.length;i++){
      //     formData.append(`amenities[${i}]`, selectedAminities[i]);
      //    }
      //   }
      //   if(selectedtype==='house' ||  selectedtype==='villas'){
      //     formData.append("plot_area", Number(property.plotArea));
      //   }
      //   if(selectedtype==='plots' ){
      //     formData.append("plot_area", Number(property.plotArea));
      //     formData.append("length", Number(property.length));
      //     formData.append("breadth", Number(property.breadth));
      //     formData.append("road_width", Number(property.roadWidth));
      //     formData.append("price", Number(property.price));
      //   }
      //   if(selectedtype==='villas'){
         
      //    for(var i=0;i<selectedAminities.length;i++){
      //     formData.append(`amenities[${i}]`, selectedAminities[i]);
      //    }
      //   }
      //   if(selectedtype==='office-space' ){
      //     formData.append("build_up_area", Number(property.buildUpArea));
      //     formData.append("carpet_area", Number(property.carpetArea));
      //     formData.append("furnished", property.furnished);
      //     formData.append("no_of_floors", Number(property.noOfFloors));
      //     formData.append("floor_number", Number(property.floorNumber));
      //     formData.append("garage", Number(property.garage));
      //     formData.append("price", Number(property.price));
      //   }
      //   if(levels==='rent' && selectedtype!=='plots'){
      //     formData.append("maintenanceCharge", Number(property.maintenanceCharge));
  
      //   }



      const data = {
        property_name: property.propertyName,
        property_ad_title: property.propertyAdTitle,
        description: property.description,
        contact_person: selecteduser?.value,
        property_type: selectedptype,
        ...(selectedImageId.length > 0 && { property_images: selectedImageId.map((img) => img.id) }),
        // property_images: selectedImageId.map((img) => img.id),
        year_of_construction: property.yearOfConstruction ? Number(property.yearOfConstruction) : undefined,
        listed_by: property.listedBy || undefined,
        condition: property.condition || undefined,
        property_location: location.name,
        google_address_string: addressstring,
        property_city: city,
        property_country: country,
        property_sub_location: subloc,
        longitude: location.long,
        latitude: location.lat,
        status: property.status,
        meta_title: property.metaTitle,
        meta_description: property.metaDescription,
        canonicalURL: property.canonicalURL,
        soldOutStatus: property.soldOut,
        soldOutDate: property.soldOutDate,
      };
      
      // Add extra fields conditionally
      if (["house", "apartment", "villas"].includes(selectedtype)) {
        data.bedrooms = property.bedrooms;
        data.bathrooms = Number(property.bathrooms);
        data.balcony = Number(property.balcony);
        data.build_up_area = Number(property.buildUpArea);
        data.carpet_area = Number(property.carpetArea);
        data.furnished = property.furnished;
        data.no_of_floors = Number(property.noOfFloors);
        data.garage = Number(property.garage);
        data.road_width = Number(property.roadWidth);
        data.price = Number(property.price);
      }
      
      if (selectedtype === "apartment") {
        data.type = property.type;
        data.floor_number = Number(property.floorNumber);
        data.amenities = selectedAminities;
      }
      
      if (["house", "villas"].includes(selectedtype)) {
        data.plot_area = Number(property.plotArea);
        if (selectedAminities.length > 0) {
          data.amenities = selectedAminities;
        }
      }
      
      if (selectedtype === "plots") {
        data.plot_area = Number(property.plotArea);
        data.length = Number(property.length);
        data.breadth = Number(property.breadth);
        data.road_width = Number(property.roadWidth);
        data.price = Number(property.price);
      }
      
      if (selectedtype === "office-space") {
        data.build_up_area = Number(property.buildUpArea);
        data.carpet_area = Number(property.carpetArea);
        data.furnished = property.furnished;
        data.no_of_floors = Number(property.noOfFloors);
        data.floor_number = Number(property.floorNumber);
        data.garage = Number(property.garage);
        data.price = Number(property.price);
      }
      
      if (levels === "rent" && selectedtype !== "plots") {
        data.maintenanceCharge = Number(property.maintenanceCharge);
      }
      
        axios
        .put(`${Config.apiurl}${Urls}${id}`, data,{ headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",
        },}).then((res) => {

          if (res.status === 200 ){
            setToastmodal(true);
            setToastmessage("Sucessfully updated Property ");
            setToasttype("success");
            setToastlarge(false);
            // setTimeout(() => navigate("/dashboard"), 3000);
          }
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage("Something went wrong!");
            setToasttype("error");
            setToastlarge(false);
          }
        });
      }
   };

   const getcust = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/property/contact-person-dropdown`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setCust(data);
    }
    else if (res.status === 401) {
      handleUnauthorized();
      getcust();
    }
    else {
      console.log("error!");
    }
  };

  const getproperty = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/property-types/get-property-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const data = await res.json();
    if (res.status === 200 ) {
     
      setProprtytype(data.data);
    }
    else if (res.status === 401) {
      handleUnauthorized();
      getproperty();
    }
  };

    useEffect(()=>{
      if(selectedptype && propertytype){
        for(let i=0;i<propertytype.length;i++){
          if(selectedptype===propertytype[i]._id){
            setselectedType(propertytype[i].propertyTypeSlug);

          }
        }
      }

    },[selectedptype ,propertytype])

    useEffect(()=>{
      const updatedAminity = [...aminity]; // Create a copy to avoid mutating state directly
  
      const updatedAminityall = aminityall.filter((item) =>  item !== 'Others');
      setSelectedAminities(updatedAminityall);

      for (let i = 0; i < updatedAminityall.length; i++) {
        if (!updatedAminity.some((item) => item.value === updatedAminityall[i])) {
          updatedAminity.push({
            label:updatedAminityall[i],
            value:updatedAminityall[i]
            }
            );
        }
      }
      setAminity(updatedAminity);
        
  
      // Remove items from aminityall that are in aminity
      // const updatedAminityall = aminityall.filter((item) =>  item !== 'Others');
    }, [aminityall]);


  const getinfo1 = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/amenities/get-amenity`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setAminity(data.data);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo1();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo1();
  }, []);
   useEffect(()=>{
    getinfo();
    getcust();
    getproperty();
   },[])

   const formattedSoldOutDate = property.soldOutDate
    ? new Date(property.soldOutDate).toISOString().split('T')[0]
    : '';

    useEffect(()=>{
      const options = cust.map(item => ({ value: item?._id, label: item?.name }));
      setUseroption(options);
    },[cust])

    useEffect(()=>{
      const matched = useroption.find(opt => opt.value === contactPerson);
      setSelecteduser(matched || null);
    },[useroption,contactPerson])
  

    return (
    <div>
        <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Property Type</h4>
                        <p className="card-description">Edit Property Type ({levels})</p>
                        <form className="forms-sample" onSubmit={PostData}>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Ad Title <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                placeholder="Property Ad Title"
                                className="form-control"
                                id="exampleInputUsername1"

                                name="propertyAdTitle"
                                value={property.propertyAdTitle}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.propertyAdTitle}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Name <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Property Name"
                                name="propertyName"
                                value={property.propertyName}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.propertyName}</label>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Description <span style={{ color: "red" }}>*</span></label>
                              <textarea
                                rows="4"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Description"
                                name="description"
                                value={property.description}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.description}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Contact Person <span style={{ color: "red" }}>*</span></label>
                              {/* <select className="form-select" name="contactPerson"
                                value={contactPerson}
                                onChange={(e)=>setContactperson(e.target.value)}>
                                <option>
                                  Select..
                                </option>
                                {cust.map((cu, i) => {
                                  return (
                                    <option value={cu._id}>{cu.name}</option>
                                  )
                                })}
                              </select> */}
                            <Select 
                            options={useroption}
                            isSearchable={true}
                            value={selecteduser}
                            className="my-select"
                            onChange={setSelecteduser}
                            // placeholder="Select the number of bedrooms"
                            />
                              <label style={{ color: "red" }}>{formerror.contactPerson}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Type <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="propertyType"
                                value={selectedptype}
                                onChange={(e) => handleInputstype(e, e.target.selectedOptions[0].getAttribute('data-slug'))}>
                                <option>
                                  Select..
                                </option>
                                {propertytype.map((pro, i) => {
                                  return (
                                    <option value={pro._id} data-slug={pro.propertyTypeSlug}>{pro.propertyType}</option>
                                  )
                                })}


                              </select>

                              <label style={{ color: "red" }}>{formerror.propertyType}</label>
                            </div>
                          </div>
                          {selectedtype === 'apartment' ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Type <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="type"
                                    value={property.type}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value="flat">Flat</option>
                                    <option value="apartment">Apartment</option>


                                  </select>

                                  <label style={{ color: "red" }}>{formerror.type}</label>
                                </div>
                              </div>
                            </>
                            

                            : ""}

                          {selectedtype === 'house' || selectedtype === 'apartment' || selectedtype==='villas'  ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Bed Rooms <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="bedrooms"
                                    value={property.bedrooms}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value="1_BHK">1 Bhk</option>
                                    <option value="2_BHK">2 Bhk</option>
                                    <option value="3_BHK">3 Bhk</option>
                                    <option value="4_BHK">4 Bhk</option>
                                    <option value="4_PLUS_BHK">5+ Bhk</option>

                                  </select>

                                  <label style={{ color: "red" }}>{formerror.bedrooms}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Bathrooms <span style={{ color: "red" }}>*</span></label>
                                 

                            <select className="form-select" name="bathrooms"
                                    value={property.bathrooms}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                  </select>
                                  <label style={{ color: "red" }}>{formerror.bathrooms}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Balcony</label>
                                  <select className="form-select" name="balcony" value={property.balcony} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.balcony}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Build Up Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Build Up Area"
                                    name="buildUpArea"
                                    value={property.buildUpArea}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.buildUpArea}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Carpet Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Carpet Area"
                                    name="carpetArea"
                                    value={property.carpetArea}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.carpetArea}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Furnished <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="furnished" value={property.furnished} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value="Fully furnished">Fully Furnished</option>
                                    <option value="Semi furnished">Semi Furnished</option>
                                    <option value="Un furnished">Un Furnished</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.furnished}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Number of Floors</label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Number of Floors"
                                    name="noOfFloors"
                                    value={property.noOfFloors}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.noOfFloors}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Garage</label>
                                  <select className="form-select" name="garage" value={property.garage} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.garage}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Road Width</label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Road Width"
                                    name="roadWidth"
                                    value={property.roadWidth}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.roadWidth}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Price"
                                name="price"
                                value={property.price}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.price}</label>
                            </div>
                          </div>
                            </>
                            : ""}

                          {selectedtype === 'house' || selectedtype==='villas' ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Plot Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Plot Area"
                                    name="plotArea"
                                    value={property.plotArea}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.plotArea}</label>
                                </div>
                              </div>
                            </>

                            : ''
                          }

                          {selectedtype==='apartment'?
                        <>
                          <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Floor number</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                             
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Floor number"
                              name="floorNumber"
                              value={property.floorNumber}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.floorNumber}</label>
                          </div>
                        </div>

                       
                          <div className="col-md-12">
                        <div className="amenities-section">
                        <h3>Amenities <span style={{ color: "red" }}>*</span></h3>
                        <div className="amenities-grid">
                            {aminity.map((ami,i)=>{
                                return(
                                    <label> {ami.title}<input type="checkbox" name="amenities" value={ami.title}  checked={selectedAminities.includes(ami.title)}  onChange={() => handleCheckboxChange(ami.title)}/></label>
                                )
                            })}
                                <label>Others<input type="checkbox" name="amenities" value='Others' checked={selectedAminities.includes('Others')}  onChange={() => handleCheckboxChange('Others')}/></label>

                        </div>
                        {showInput && (
                            <div className='amenities_input_section col-md-6'>
                                <input
                                    type="text"
                                    placeholder="Enter the amenities"
                                    className="amenities-input"
                                    value={newAminity}
                                    onChange={(e) => setNewAminity(e.target.value)}
                                />
                                <button type="button" className='amenities_btns' onClick={handleAddAminity}><FiPlusCircle /></button>
                            </div>
                            )}
                    </div>
                         </div>
                        
                        </>  
                        :""
                        }
                        {selectedtype==='plots'?
                      <>
                      
                      <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Plot Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Plot Area"
                              name="plotArea"
                              value={property.plotArea}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.plotArea}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Length <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Length"
                              name="length"
                              value={property.length}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.length}</label>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Breadth <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Breadth"
                              name="breadth"
                              value={property.breadth}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.breadth}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Road Width</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Road Width"
                              name="roadWidth"
                              value={property.roadWidth}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.roadWidth}</label>
                          </div>
                        </div>
                        <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Price"
                                name="price"
                                value={property.price}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.price}</label>
                        </div>
                        
                      </>  
                      :""
                      }
                      {selectedtype==='villas' ?
                    <>
                    <div className="col-md-12">
<div className="amenities-section">
<h3>Amenities <span style={{ color: "red" }}>*</span></h3>
<div className="amenities-grid">
    {aminity.map((ami,i)=>{
        return(
          <label> {ami.title}<input type="checkbox" name="amenities" value={ami.title}  checked={selectedAminities.includes(ami.title)}  onChange={() => handleCheckboxChange(ami.title)}/></label>
          )
    })}
    <label>Others<input type="checkbox" name="amenities" value='Others' checked={selectedAminities.includes('Others')}  onChange={() => handleCheckboxChange('Others')}/></label>

</div>
{showInput && (
    <div className='amenities_input_section col-md-6'>
        <input
            type="text"
            placeholder="Enter the amenities"
            className="amenities-input"
            value={newAminity}
            onChange={(e) => setNewAminity(e.target.value)}
        />
        <button type="button" className='amenities_btns' onClick={handleAddAminity}><FiPlusCircle /></button>
    </div>
    )}
</div>
 </div>
                    </>  
                    :""
                    }

                    {selectedtype==='office-space'?
                    
                  <>
                      <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Build Up Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Build Up Area"
                              name="buildUpArea"
                              value={property.buildUpArea}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.buildUpArea}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Carpet Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Carpet Area"
                              name="carpetArea"
                              value={property.carpetArea}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.carpetArea}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Furnished <span style={{ color: "red" }}>*</span></label>
                            <select className="form-select" name="furnished" value={property.furnished} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value="Fully furnished">Fully Furnished</option>
                              <option value="Semi furnished">Semi Furnished</option>
                              <option value="Un furnished">Un Furnished</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.furnished}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Number of Floors</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Number of Floors"
                              name="noOfFloors"
                              value={property.noOfFloors}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.noOfFloors}</label>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Floor number</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Floor number"
                              name="floorNumber"
                              value={property.floorNumber}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.floorNumber}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Garage</label>
                            <select className="form-select" name="garage" value={property.garage} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value={1}>1</option>
                              <option value={2}>2</option>
                              <option value={3}>3</option>
                              <option value={4}>4</option>
                              <option value={5}>5</option>
                              <option value={6}>6</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.garage}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Price"
                              name="price"
                              value={property.price}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.price}</label>
                          </div>
                        </div>
                  
                  </>
                  :""
                  }

                    {levels==='rent' && selectedtype!=='plots'?
                    
                    <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Maintenance Charges <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Maintenanace Charge"
                        name="maintenanceCharge"
                        value={property.maintenanceCharge}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>{formerror.maintenanceCharge}</label>
                    </div>
                  </div>
                  :""
                  
                  }
                                      {selectedtype==='house' || selectedtype==='apartment' || selectedtype==='villas'?

                            <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Year of Construction</label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Year of construction"
                                    name="yearOfConstruction"
                                    value={property.yearOfConstruction}
                                    onChange={handleInputs}
                                  />
                                
                                </div>
                              </div>
                              :""}
                             
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Listed By <span style={{ color: "red" }}>*</span></label>
                            <select className="form-select" name="listedBy" value={property.listedBy} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value="owner">Owner</option>
                              <option value="broker">Broker</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.listedBy}</label>
                          </div>
                        </div>
                        <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Condition</label>
                                  <textarea
                                 rows={3}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Condition"
                                    name="condition"
                                    value={property.condition}
                                    onChange={handleInputs}
                                  />
                                
                                </div>
                              </div>
                  
                        
                          {/* <div className="col-md-6">

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Property State</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Property State"
                              name="property_state"
                              value={property.property_state}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.property_state}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Property District</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Property District"
                              name="property_district"
                              value={property.property_district}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.property_district}</label>
                          </div>
                        </div> */}



                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">
                              Location <span style={{ color: "red" }}>*</span>
                            </label>
                            <PlacesAutocomplete
                              value={location.name}
                              onChange={handleChange}
                              onSelect={handleSelect}
                              name="location"
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div className="position-relative">
                                  <input
                                    className="form-control"
                                    {...getInputProps({
                                      placeholder: " Enter your location",
                                    })}
                                    required
                                  />

                                  <div className="autocomplete-dropdown-container">
                                    {loading ? <div>...Loading</div> : null}

                                    {suggestions.map((suggestion, key) => {
                                      const style = suggestion.active
                                        ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                        : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                      return (
                                        <div
                                          className="form-conterol"
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                          key={key}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                          </div>


                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Meta Title <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Meta Title"
                                name="metaTitle"
                                value={property.metaTitle}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.metaTitle}</label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Canonical URL <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Canonical URL"
                                name="canonicalURL"
                                value={property.canonicalURL}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.canonicalURL}</label>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Meta Description</label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Meta Description"
                                name="metaDescription"
                                value={property.metaDescription}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.metaDescription}</label>
                            </div>
                          </div>
                          <div className="col-md-12">

                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Upload Images <span style={{ color: "red" }}>*</span></label>
                              <br></br>
                              <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                              {/* <input type="file" name="file" onChange={onFileChange} multiple accept="image/png, image/jpeg ,image/jpg,image/webp"/> */}
                              <div className='clearfix mb-2'></div>

                              <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>
                              <label style={{ color: "red" }}>{formerror.image}</label>

                              <p>Old Images</p>   
                              {property.propertyImages ?
                                property.propertyImages.map((img,ib)=>{
                                return(
                                  <img src={img.imageFile} style={{ width: "100px", height: "100px", marginTop: "5px",marginRight: "10px" }} />
                                  )}

                                )

                                :
                                ""
                              }


                              <label style={{ color: "red" }}>{formerror.file}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Status <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="status" value={property.status} onChange={handleInputs}>
                                <option>Select..</option>
                                <option value='Pending'>Pending</option>
                                <option value='Listed'>Listed</option>
                                <option value='Unlisted'>Un listed</option>
                                <option value='Sold Out'>Sold Out</option>

                              </select>
                              <label style={{ color: "red" }}>{formerror.status}</label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Sold out status <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="soldOut" value={property.soldOut} onChange={handleInputs}>
                                <option value={true}>True</option>
                                <option value={false}>False</option>
                              </select>
                              <label style={{ color: "red" }}>{formerror.soldOut}</label>
                            </div>
                          </div>
                        
                          {property?.status==='Sold Out'?
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Sold out date <span style={{ color: "red" }}>*</span></label>
                              <input type="date" max={maxDate} className="form-select" name="soldOutDate" value={formattedSoldOutDate} onChange={handleInputs}  onClick={(e) => e.target.showPicker()}/>
                            
                              <label style={{ color: "red" }}>{formerror.soldOutDate}</label>
                            </div>
                          </div>
                          :""}
                        </div>
                          <button
                            type="submit"
                            onClick={PostData}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>

                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
      </div>
  )
}

export default Propertyedit
